export default {
   API_ENDPOINT: 'https://young-hollows-16796.herokuapp.com/api'
}